import React from "react"
import EmailBuilderGeneral from "./tabs/EmailBuilderGeneral"
import EmailBuilderSources from "./tabs/EmailBuilderSources"
import EmailBuilderRoomTypes from "./tabs/EmailBuilderRoomTypes"
import EmailBuilderProperties from "./tabs/EmailBuilderProperties"

export default class EmailBuilderWorkspace extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="tab-content">
        <EmailBuilderGeneral {...this.props} />
        {this.props.origin != 'superadmin' && this.props.email && this.props.email.email_type != 'internal'
        ?
        <>
        <EmailBuilderSources {...this.props} />
        <EmailBuilderRoomTypes {...this.props} />
        </>
        :
        null
        }
        {this.props.email && this.props.email.email_type == 'internal'
        ?
        <EmailBuilderProperties {...this.props} />
        :
        null
        }
      </div>
    )
  }

};